import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ PAYMENT ]';

const Actions = {
	setPaymentOption: `${MODULE_PREFIX} setPaymentOption`,
	setPaymentDetails: `${MODULE_PREFIX} setPaymentDetails`,
};

export const setPaymentOption = createAction(Actions.setPaymentOption);
export const setPaymentDetails = createAction(Actions.setPaymentDetails);

export const getPaymentDetails = (state) => {
	const paymentDetails = get(state, 'payment.paymentDetails', {});
	return paymentDetails;
};

export const getPaymentOption = (state) => {
	const paymentOption = get(state, 'payment.paymentOption', '');
	return paymentOption;
};

const initialState = {
	paymentDetails: {},
	paymentOption: '',
};

export default createReducer(initialState, (builder) => {
	builder.addCase(setPaymentDetails, (state, action) => {
		state.paymentDetails = action.payload;
	});
	builder.addCase(setPaymentOption, (state, action) => {
		state.paymentOption = action.payload;
	});
});
